import React, { Component } from 'react';
import fire from './fire';
import WhoToUse from './whoToUse';

class WritingSelector extends Component {
  static whyDidYouRender = true;

  constructor(props) {
    super(props);
  }


  render() {
    let writingOptions;

    // TODO: rather inefficient way to render this below, but for some reason when i used writingOptions.push, the this.props.handleWritingSelection(writing_id) writing_id reference was being determined to be the very last writing_id rendered, not preserving their individuality.

    // Each of the Authors Documents
    if (this.props.betterWritings){
      writingOptions = Array.from(this.props.betterWritings.keys()).map((writing_id) =>
        <div className="writing-file" key={writing_id} onClick={()=>this.props.handleWritingSelection(writing_id)}>
          {this.props.betterWritings.get(writing_id)}
        </div>
      );
    }

    // The New Document Document
    writingOptions.push(
      <div
        className="writing-file new-writing"
        key="@@New-Writing"
        onClick={()=>this.props.handleNewWriting()}>

        <div className="plus">+</div>
        New Document
      </div>
    );


    return (
      <div className="internal-frame">
        <div className="writing-selector">
          <h2 className="title">Choose a Document:</h2>
          <div>
            {writingOptions}
          </div>
        </div>

        <div id="help-info">
          <WhoToUse/>
        </div>
      </div>
    );
  }
}
export default WritingSelector;
